<template>
  <div>
    
     <span
        data-bs-toggle="tooltip"
        data-bs-placement="top"
        :title="!disabled? 'พิมพ์ใบกำกับ '+aiCode : 'ไม่มีรายการให้พิมพ์'"
        class="d-inline-block"
      >
        <button
          :class="btnClass"
          v-bind="$attrs"
          @click="PrintAIFromERP"
          :disabled="disabled"
          style="pointer-events: auto;"
        >
          <span class="position-relative font-small" tabindex="-1">
            <i class="fas fa-file-invoice"
              :style="[btnClass!='btn btn-link btn-sm' ? 'color: #fff' : '']"></i>

            <span
              v-if="printNum > 0"
              class="position-absolute top-0 start-200 translate-middle badge rounded-pill">
              {{printNum}}
            </span>
          </span>
        </button>
      </span>

    
    <pdf-viewer ref="pdfViewerRef"></pdf-viewer>
  </div>
  
</template>


<script>

import PdfViewer from "../modals/forms/PdfViewer.vue";
import ApiService from "../../core/services/ApiService";
import Swal from "sweetalert2/dist/sweetalert2.js";
import * as bootstrap from 'bootstrap'

export default {
  components: { PdfViewer },
  props: {
    uoRefNo: String,
    class:String,
    printNum:Number,
    disabled:Boolean,
    aiCode:String
  },
  data() {
    return {
      btnClass:"btn btn-link btn-sm ms-5",
      printNumShow:0,
      url:""
    };
  },
  mounted(){
     if(this.class){
        this.btnClass = this.class;
     }
    this.printNumShow = this.printNum;
    const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
    tooltipTriggerList.forEach(el => {
      new bootstrap.Tooltip(el)
    })
    
  },
  methods: {
    PrintAIFromERP: async function () {

      console.log("PrintAIFromERP");

      const loader = this.$loading.show();
      try {
        var tempData;
          // const { data } = await ApiService.post("Orders/AddShipmentData", {
          //   uoRefNo:this.uoRefNo,
          //   // productSelected:this.productSelected
          // });
          // tempData = data;
          // // this.$swal("สำเร็จ", "บันทึกข้อมูลส่งสินค้าแล้ว", "success");
          // this.$emit("update");
          // await ApiService.get("Orders/GetURLPrintAIFromERP?UORefNo="+this.uoRefNo)
          let url = "orders/GetURLPrintAIFromERP"
           ApiService.query(
            url, 
            {
              params: {
                UORefNo:this.uoRefNo
              }
            }).then(res => {
            //  this.printNumShow = res.data;
            this.url = res.data;
            this.$refs.pdfViewerRef.show({ url: this.url });
            console.log(" this.url", res);
            this.$emit("refresh");
            // this.pdf();
          });
  
          
          
      } catch (error) {
        Swal.fire({
          text: "เกิดข้อผิดพลาด ไม่สามารถโหลดเอกสารได้!",
          icon: "warning",
          buttonsStyling: false,
          confirmButtonText: "ปิด",
          allowOutsideClick: false,
          customClass: {
            confirmButton: "btn btn-primary",
          },
        }).then(() => {
          //this.hide();
        });
      }
      this.btnLoading = false;
      loader.hide();

    }, 
    pdf() {
      // console.log(this.uoRefNo);
      // this.$emit("update");
      // let url = "pdf/delivery/orderfrom2s/" + this.uoRefNo

      // if(this.partnerCode ) {
      //   url = "pdf/delivery/orderfrom2s/" + this.partnerCode + "/" + this.uoRefNo;
      // }

      this.$http
        .get(this.url, {
          responseType: "blob",
        })
        .then((res) => {
          //console.log(res, res.data);
          var file = new Blob([res.data], { type: "application/pdf" });
          var fileURL = URL.createObjectURL(file);
          //window.open(fileURL);
          //this.$emit("viewShow")
          this.$refs.pdfViewerRef.show({ url: fileURL });
        });
      
    },
  }
}
</script>
<style scoped>
  .btn-green {
    color: #fff;
    background-color: #35a5b6;
    border-color: #117a8b;
  }
  .btn-dark-green {
      color: #fff;
      background-color: #066f8f;
  }
</style>